import { FC, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';

import { AuthModal } from 'shared/components/SuperhostPage/AuthModal';
import { Contest } from 'shared/components/SuperhostPage/Contest';
import { Criteria } from 'shared/components/SuperhostPage/Criteria';
import { Faq } from 'shared/components/SuperhostPage/Faq';
import { Features } from 'shared/components/SuperhostPage/Features';
import { Footer } from 'shared/components/SuperhostPage/Footer';
import { FormStep } from 'shared/components/SuperhostPage/FormStep';
import { Header } from 'shared/components/SuperhostPage/Header';
import { Hero } from 'shared/components/SuperhostPage/Hero';
import { LoginStep } from 'shared/components/SuperhostPage/LoginStep';
import { Preview } from 'shared/components/SuperhostPage/Preview';
import { Promo } from 'shared/components/SuperhostPage/Promo';
import { Requirements } from 'shared/components/SuperhostPage/Requirements';
import { StickerRules } from 'shared/components/SuperhostPage/StickerRules';
import { TApplicationState } from 'shared/types/redux';

import style from './SuperhostContainer.css';

export const SuperhostContainer: FC = () => {
  const [isAuthModalOpen, setAuthModalOpen] = useState(false);
  const isAuthenticated = useSelector<TApplicationState, boolean>(state => state.user.userId !== null);
  const handleAuthModalOpen = useCallback(() => {
    if (!isAuthenticated) {
      setAuthModalOpen(true);
    }
  }, [isAuthenticated]);
  const handleAuthModalClose = useCallback(() => setAuthModalOpen(false), []);

  return (
    <div className={style['page']}>
      <div className={style['hero-section']}>
        <Header isAuthDisabled={isAuthenticated} onAuthClick={handleAuthModalOpen} />
        <Hero />
      </div>
      <Features />
      <Requirements />
      <Criteria />
      <Preview />
      <Promo />
      <StickerRules />
      <LoginStep isAuthDisabled={isAuthenticated} onAuthClick={handleAuthModalOpen} />
      <FormStep />
      <Contest />
      <Faq />
      <Footer />
      <AuthModal isOpen={isAuthModalOpen} onClose={handleAuthModalClose} />
    </div>
  );
};
